export default "__VITE_ASSET__e910dc04__"